function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BusinessTermService from '@/apps/data-platform/services/master_data/business_term_service';
import TablesService from '@/apps/data-platform/services/tables_views/tables_service';
import TblDatasourceService from '@/apps/data-platform/services/visualization/tbl_datasource_service';
import TblDashboardService from '@/apps/data-platform/services/visualization/tbl_dashboard_service';
import InformMassiveUpload from '@/components/InformMassiveUpload.vue';
import { bulkLoadMixin } from '@/mixins/bulk_load';
import tasks from "@/js/tasks";
import { mapState } from 'vuex';
import Papa from 'papaparse';
import { GA_EVENTS, BIGQUERY_TYPES, FOH_DOMAINS, isFOHDomain } from '@/js/constants';
var bulkTable = 'table';
var bulkDatasource = 'datasource';
var bulkDashboard = 'dashboard';
var bulkBusiness = 'business';
// Solo FOH (y entorno local): la carga de tablas se divide en dos plantillas
var bulkTableMetadata = 'table_metadata';
var bulkColumnMetadata = 'column_metadata';
var bulkTemplates = {};
var bulkDummy = {};
var bulkSchemas = {};
bulkTemplates[bulkTable] = 'org;domain;subdomain;official_source;proyecto;dataset;Table;description;operator;public;env;zone;area;bus_data_steward;data_owner;tech_data_custodiam;table_load_logic;tables_relationship;final_table;Table1;Column;data_element_name;business_definition;transformation_logic;sensitive;type;length;valid_values;primary_key;null;encrypted;column_load_logic';
bulkDummy[bulkTable] = "\nINTERCORP;CLIENTES;CLIENTES;ORACLE;piloto-druid-spsa;caldana;tmp_clientes_total_7;tabla dummy;gyupanqui@intercorp.com.pe;N;dev;MASTER;general;Null;Null;Null;Null;Null;N;tmp_clientes_total_7;config_id;ok;ok;lineal;N;STRING;10;Null;N;N;N;Null\nINTERCORP;CLIENTES;CLIENTES;ORACLE;piloto-druid-spsa;caldana;tmp_clientes_total_7;tabla dummy;gyupanqui@intercorp.com.pe;N;dev;MASTER;general;Null;Null;Null;Null;Null;N;tmp_clientes_total_7;element_id;ok;ok;lineal;N;STRING;10;Null;Y;N;N;Null\nINTERCORP;CLIENTES;CLIENTES;ORACLE;piloto-druid-spsa;caldana;tmp_clientes_total_7;tabla dummy;gyupanqui@intercorp.com.pe;N;dev;MASTER;general;Null;Null;Null;Null;Null;N;tmp_clientes_total_7;element_value;ok;ok;lineal;N;STRING;10;Null;N;N;N;Null\nINTERCORP;CLIENTES;CLIENTES;ORACLE;piloto-druid-spsa;caldana;tmp_clientes_total_7;tabla dummy;gyupanqui@intercorp.com.pe;N;dev;MASTER;general;Null;Null;Null;Null;Null;N;tmp_clientes_total_7;rule_id;ok;ok;lineal;N;STRING;10;Null;N;N;N;Null\n";
bulkSchemas[bulkTable] = {
  org: {
    type: 'string',
    default: '',
    required: true
  },
  domain: {
    type: 'string',
    default: '',
    required: true
  },
  subdomain: {
    type: 'string',
    default: '',
    required: true
  },
  official_source: {
    type: 'string',
    default: '',
    required: true
  },
  proyecto: {
    type: 'string',
    default: '',
    required: true
  },
  dataset: {
    type: 'string',
    default: '',
    required: true
  },
  Table: {
    type: 'string',
    default: '',
    required: true
  },
  description: {
    type: 'string',
    default: '',
    required: false
  },
  operator: {
    type: 'string',
    default: '',
    required: true
  },
  public: {
    type: 'string',
    default: 'N',
    required: false,
    valid_values: ['Y', 'N', 'true', 'false']
  },
  env: {
    type: 'string',
    default: 'prod',
    required: true,
    valid_values: ['dev', 'prod']
  },
  zone: {
    type: 'string',
    default: 'OTHER',
    required: true
  },
  area: {
    type: 'string',
    default: 'general',
    required: true
  },
  upload_platform: {
    type: 'string',
    default: '',
    required: false
  },
  upload_process: {
    type: 'string',
    default: '',
    required: false
  },
  final_table: {
    type: 'string',
    default: 'Y',
    required: false,
    valid_values: ['Y', 'N', 'true', 'false']
  },
  Table1: {
    type: 'string',
    default: '',
    required: false
  },
  Column: {
    type: 'string',
    default: '',
    required: true
  },
  data_element_name: {
    type: 'string',
    default: '',
    required: false
  },
  business_definition: {
    type: 'string',
    default: '',
    required: false
  },
  transformation_logic: {
    type: 'string',
    default: '',
    required: false
  },
  sensitive: {
    type: 'string',
    default: 'N',
    required: false,
    valid_values: ['Y', 'N', 'true', 'false']
  },
  type: {
    type: 'string',
    default: 'STRING',
    required: false
  },
  length: {
    type: 'string',
    default: '0',
    required: false
  },
  valid_values: {
    type: 'string',
    default: '',
    required: false
  },
  primary_key: {
    type: 'string',
    default: 'N',
    required: false,
    valid_values: ['Y', 'N', 'true', 'false']
  },
  null: {
    type: 'string',
    default: 'N',
    required: false,
    valid_values: ['Y', 'N', 'true', 'false']
  },
  encrypted: {
    type: 'string',
    default: 'N',
    required: false,
    valid_values: ['Y', 'N', 'true', 'false']
  }
};

// ===== Metadata de tablas (FOH): formato campo-valor, una fila por metadato a actualizar =====
bulkTemplates[bulkTableMetadata] = 'proyecto;dataset;tabla;campo_metadata;valor_a_asignar';

// La primera fila (empieza con #) describe cada columna y se ignora al cargar
bulkDummy[bulkTableMetadata] = "\n# Proyecto GCP donde vive la tabla. Ej: proyecto-ejemplo;Dataset de BigQuery. Ej: dataset_ejemplo;Nombre de la tabla registrada en INCA;Campo de metadata a actualizar. Valores posibles: descripcion | operador | publico (Y/N) | entorno (dev/prod) | zona | area (general) | organizacion | dominio | subdominio | fuente_de_datos | bus_data_steward | data_owner | tech_data_custodiam | logica_de_carga | relacion_entre_tablas | plataforma_de_carga | proceso_de_carga | tabla_final (Y/N). Tambien se aceptan los nombres internos en ingles (description | operator | public | env...);Valor a escribir en el campo. Correos con dominio somosoh.pe o ifxp.pe. Campos Y/N aceptan: Y | N | true | false. Esta fila se ignora automaticamente al cargar\nproyecto-ejemplo;dataset_ejemplo;tabla_ejemplo;descripcion;Tabla de clientes activos\nproyecto-ejemplo;dataset_ejemplo;tabla_ejemplo;operador;usuario@ifxp.pe\nproyecto-ejemplo;dataset_ejemplo;tabla_ejemplo;publico;N\nproyecto-ejemplo;dataset_ejemplo;tabla_ejemplo;zona;MASTER\n";
bulkSchemas[bulkTableMetadata] = {
  proyecto: {
    type: 'string',
    default: '',
    required: true
  },
  dataset: {
    type: 'string',
    default: '',
    required: true
  },
  tabla: {
    type: 'string',
    default: '',
    required: true
  },
  campo_metadata: {
    type: 'string',
    default: '',
    required: true
  },
  valor_a_asignar: {
    type: 'string',
    default: '',
    required: true
  }
};

// Campos de metadata de tabla actualizables y su validación de valor
var TABLE_METADATA_FIELDS = {
  org: {
    foh_value: 'FINANCIERA OH!'
  },
  domain: {},
  subdomain: {},
  official_source: {},
  description: {},
  operator: {
    email: true
  },
  public: {
    valid_values: ['Y', 'N', 'true', 'false']
  },
  env: {
    valid_values: ['dev', 'prod']
  },
  zone: {},
  area: {
    foh_value: 'general'
  },
  bus_data_steward: {
    email: true
  },
  data_owner: {
    email: true
  },
  tech_data_custodiam: {
    email: true
  },
  table_load_logic: {},
  tables_relationship: {},
  upload_platform: {},
  upload_process: {},
  final_table: {
    valid_values: ['Y', 'N', 'true', 'false']
  }
};

// Nombres en español aceptados en campo_metadata (claves normalizadas:
// minúsculas, sin acentos, espacios como "_")
var TABLE_METADATA_FIELD_ALIASES = {
  organizacion: 'org',
  dominio: 'domain',
  subdominio: 'subdomain',
  fuente_de_datos: 'official_source',
  descripcion: 'description',
  descripcion_de_la_tabla: 'description',
  operador: 'operator',
  publico: 'public',
  entorno: 'env',
  zona: 'zone',
  business_data_steward: 'bus_data_steward',
  dueno_de_datos: 'data_owner',
  custodio_tecnico: 'tech_data_custodiam',
  tech_data_custodian: 'tech_data_custodiam',
  logica_de_carga: 'table_load_logic',
  relacion_entre_tablas: 'tables_relationship',
  plataforma_de_carga: 'upload_platform',
  proceso_de_carga: 'upload_process',
  tabla_final: 'final_table'
};

// Normaliza el nombre del campo (español o inglés) al nombre interno
function normalizeMetadataField(raw) {
  var s = String(raw === undefined || raw === null ? '' : raw).trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, '_');
  return TABLE_METADATA_FIELD_ALIASES[s] || s;
}

// ===== Metadata de columnas (FOH): una fila por columna, la tabla ya debe existir =====
// type, length y null no se cargan por CSV: salen del esquema real de BigQuery
bulkTemplates[bulkColumnMetadata] = 'proyecto;dataset;Table;Column;data_element_name;business_definition;sensitive;valid_values;primary_key;encrypted;column_load_logic';
bulkDummy[bulkColumnMetadata] = "\nproyecto-ejemplo;dataset_ejemplo;tabla_ejemplo;cliente_id;Identificador de cliente;Identificador unico del cliente;N;Null;Y;N;Null\nproyecto-ejemplo;dataset_ejemplo;tabla_ejemplo;fecha_registro;Fecha de registro;Fecha de creacion del cliente;N;Null;N;N;Null\n";
bulkSchemas[bulkColumnMetadata] = {
  proyecto: {
    type: 'string',
    default: '',
    required: true
  },
  dataset: {
    type: 'string',
    default: '',
    required: true
  },
  Table: {
    type: 'string',
    default: '',
    required: true
  },
  Column: {
    type: 'string',
    default: '',
    required: true
  },
  data_element_name: {
    type: 'string',
    default: '',
    required: false
  },
  business_definition: {
    type: 'string',
    default: '',
    required: false
  },
  sensitive: {
    type: 'string',
    default: 'N',
    required: false,
    valid_values: ['Y', 'N', 'true', 'false']
  },
  valid_values: {
    type: 'string',
    default: '',
    required: false
  },
  primary_key: {
    type: 'string',
    default: 'N',
    required: false,
    valid_values: ['Y', 'N', 'true', 'false']
  },
  encrypted: {
    type: 'string',
    default: 'N',
    required: false,
    valid_values: ['Y', 'N', 'true', 'false']
  },
  column_load_logic: {
    type: 'string',
    default: '',
    required: false
  }
};
bulkTemplates[bulkDatasource] = 'organization;object_name;domain;subdomain;data_operator;environment;path_name;sensitive_data;object_description;field_name;business_definition;masked;sensitive_data';
bulkDummy[bulkDatasource] = "\nINTERCORP;FD Distrito;CLIENTES;TRANSACCIONES;gyupanqui@intercorp.com.pe;dev;Farmacias;false;Contiene informaci\xF3n de los distritos del pa\xEDs;AREA;;false;false\nINTERCORP;FD Distrito;CLIENTES;TRANSACCIONES;gyupanqui@intercorp.com.pe;dev;Farmacias;false;Contiene informaci\xF3n de los distritos del pa\xEDs;CAPITAL;;false;false\nINTERCORP;FD Distrito;CLIENTES;TRANSACCIONES;gyupanqui@intercorp.com.pe;dev;Farmacias;false;Contiene informaci\xF3n de los distritos del pa\xEDs;CODCCPP;;false;false\nINTERCORP;FD Distrito;CLIENTES;TRANSACCIONES;gyupanqui@intercorp.com.pe;dev;Farmacias;false;Contiene informaci\xF3n de los distritos del pa\xEDs;DEPARTAMEN;;false;false\nINTERCORP;FD Distrito;CLIENTES;TRANSACCIONES;gyupanqui@intercorp.com.pe;dev;Farmacias;false;Contiene informaci\xF3n de los distritos del pa\xEDs;DISTRITO;;false;false\nINTERCORP;FD Distrito;CLIENTES;TRANSACCIONES;gyupanqui@intercorp.com.pe;dev;Farmacias;false;Contiene informaci\xF3n de los distritos del pa\xEDs;FUENTE;;false;false\nINTERCORP;FD Distrito;CLIENTES;TRANSACCIONES;gyupanqui@intercorp.com.pe;dev;Farmacias;false;Contiene informaci\xF3n de los distritos del pa\xEDs;Geometry;;false;false\nINTERCORP;FD Distrito;CLIENTES;TRANSACCIONES;gyupanqui@intercorp.com.pe;dev;Farmacias;false;Contiene informaci\xF3n de los distritos del pa\xEDs;IDDIST;;false;false\nINTERCORP;FD Distrito;CLIENTES;TRANSACCIONES;gyupanqui@intercorp.com.pe;dev;Farmacias;false;Contiene informaci\xF3n de los distritos del pa\xEDs;IDDPTO;;false;false\nINTERCORP;FD Distrito;CLIENTES;TRANSACCIONES;gyupanqui@intercorp.com.pe;dev;Farmacias;false;Contiene informaci\xF3n de los distritos del pa\xEDs;IDPROV;;false;false\nINTERCORP;FD Distrito;CLIENTES;TRANSACCIONES;gyupanqui@intercorp.com.pe;dev;Farmacias;false;Contiene informaci\xF3n de los distritos del pa\xEDs;PROVINCIA;;false;false\n";
bulkTemplates[bulkDashboard] = 'organization;object_name;domain;subdomain;data_operator;environment;path_name;sensitive_data;object_description';
bulkDummy[bulkDashboard] = "\nINTERCORP;Analitica Digital v2;CLIENTES;CLIENTES;gyupanqui@intercorp.com.pe;dev;Data Office;false;carga masiva\n";
bulkTemplates[bulkBusiness] = 'business_term;definition;domain;subdomain;status;critical;values;classification;accountable;also_known_as;contains;has_a_type;is_a_related_term_from;is_a_type_of;is_calculated_from;is_contained_in;is_used_to_calculate;related_term';
bulkDummy[bulkBusiness] = "\nHASH ID;ID utilizado en Google Analytics;OPERACIONES;SISTEMAS Y PROCESOS;true;false;hash, id;id, identificador;gyupanqui@intercorp.com.pe;user id\n";
bulkSchemas[bulkBusiness] = {
  business_term: {
    type: 'string',
    default: '',
    required: true
  },
  definition: {
    type: 'string',
    default: '',
    required: false
  },
  domain: {
    type: 'string',
    default: '',
    required: true
  },
  subdomain: {
    type: 'string',
    default: '',
    required: true
  },
  status: {
    type: 'boolean',
    default: false,
    required: false
  },
  critical: {
    type: 'boolean',
    default: false,
    required: false
  },
  values: {
    type: 'string',
    default: '',
    required: false
  },
  classification: {
    type: 'string',
    default: '',
    required: false
  },
  accountable: {
    type: 'string',
    default: '',
    required: false
  },
  also_known_as: {
    type: 'string',
    default: '',
    required: false
  },
  contains: {
    type: 'string',
    default: '',
    required: false
  },
  has_a_type: {
    type: 'string',
    default: '',
    required: false
  },
  is_a_related_term_from: {
    type: 'string',
    default: '',
    required: false
  },
  is_a_type_of: {
    type: 'string',
    default: '',
    required: false
  },
  is_calculated_from: {
    type: 'string',
    default: '',
    required: false
  },
  is_contained_in: {
    type: 'string',
    default: '',
    required: false
  },
  is_used_to_calculate: {
    type: 'string',
    default: '',
    required: false
  },
  related_term: {
    type: 'string',
    default: '',
    required: false
  }
};
export default {
  name: 'ContLoadBulk',
  components: {
    InformMassiveUpload: InformMassiveUpload
  },
  mixins: [bulkLoadMixin],
  data: function data() {
    return {
      csvFile: null,
      error_message: false,
      message: '',
      messageServer: '',
      colorAlert: '',
      TYPE_ERROR: 'error',
      TYPE_WARNING: 'warning',
      TYPE_SUCCESS: 'success',
      showMessageServer: false,
      MODAL_INFORM_BULK: 'ModalBulkUpload',
      tplToInform: [],
      isLoading: false,
      bulkType: null,
      dialogFlag: false,
      bulkStep: 1,
      tableauRecords: [],
      tableauErrors: [],
      bulkStepError: false,
      isHovering: false,
      MESSAGE_WARNING_UPLOAD: 'Uploaded with some observations',
      MESSAGE_ERROR_UPLOAD: 'La carga no pudo completarse debido a errores en la metadata.\nConsulta los detalles para más información.',
      list_source: [{
        value: 'bigquery',
        text: "Bigquery"
      }, {
        value: 'synapse',
        text: "Azure Synapse"
      }],
      source: 'bigquery'
    };
  },
  created: function created() {},
  computed: _objectSpread(_objectSpread({}, mapState('data-platform', ['companyCode', 'companyName', 'isSynapseActive', 'organizations'])), {}, {
    // Carga dividida (tablas/columnas): solo dominios FOH y, para poder
    // probarla, siempre en entorno local
    showSplitBulk: function showSplitBulk() {
      return isFOHDomain(window.userInfo.domain) || process.env.VUE_APP_ENV === 'local' || process.env.NODE_ENV === 'development';
    },
    bulkOptions: function bulkOptions() {
      var options = [{
        value: null,
        text: this.traductor('my_tasks.select_option'),
        disabled: true
      }];
      if (this.showSplitBulk) {
        options.push({
          value: bulkTableMetadata,
          text: this.traductor('my_tasks.tables_metadata')
        });
        options.push({
          value: bulkColumnMetadata,
          text: this.traductor('my_tasks.columns_metadata')
        });
      } else {
        options.push({
          value: bulkTable,
          text: this.traductor('my_tasks.tables')
        });
      }
      options.push({
        value: bulkDatasource,
        text: this.traductor('my_tasks.datasources')
      });
      options.push({
        value: bulkDashboard,
        text: this.traductor('my_tasks.dashboards')
      });
      return options;
    },
    getBreadcrumbs: function getBreadcrumbs() {
      return [{
        text: this.traductor('my_tasks.subtitle_bulk_load'),
        disabled: true
      }];
    },
    load_csv: function load_csv() {
      return this.traductor('my_tasks.upload_csv');
    },
    texts: function texts() {
      return {
        bulk_load: this.traductor('frases.bulk_load')
      };
    }
  }),
  methods: {
    showBulkSimpleErrors: function showBulkSimpleErrors(data) {
      var errors = new Set();
      data.forEach(function (item) {
        (item.columns || []).forEach(function (col) {
          if (!col.success && col.message) {
            errors.add(col.message.trim());
          }
        });
      });
      if (!errors.size) return;
      var msg = Array.from(errors).join('\n') + '\n\nRevise su archivo CSV.';
      tasks.toast.error(msg);
    },
    // --- helpers para saber qué columna validar y cómo ---
    requiredDescField: function requiredDescField(bulkType) {
      // nombre del campo “descripción” según el tipo seleccionado en Paso 1
      if (bulkType === 'table') return 'description';
      if (bulkType === 'datasource' || bulkType === 'dashboard') return 'object_description';
      return null; // business no exige descripción
    },
    isInvalidText: function isInvalidText(val) {
      console.log("isInvalidText val: ".concat(val));
      var v = (val || '').trim().toLowerCase();
      return !v || /^null$/i.test(v); // vacío, espacios o "null"/"NULL"...
    },
    isInvalidEmail: function isInvalidEmail(val) {
      var v = (val || '').trim();
      console.log("isInvalidEmail val: ".concat(val));

      // Validación básica de formato de email
      if (!v || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) {
        return true;
      }

      // Validación de dominio específico para FOH/IFXP
      if (isFOHDomain(window.userInfo.domain)) {
        var emailDomain = v.split('@')[1];
        return !FOH_DOMAINS.includes(emailDomain);
      }
      return false;
    },
    isInvalidBigqueryTypes: function isInvalidBigqueryTypes(val) {
      var valid_types = BIGQUERY_TYPES;
      return !valid_types.includes((val || '').toUpperCase());
    },
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    validateFile: function validateFile(file) {
      if (!file) {
        this.error_message = true;
        this.message = 'You must choose a file at least';
        return false;
      } else if (/\.csv$/i.test(file.name)) {
        // <-- acepta .csv o .CSV
        this.error_message = false;
        return true;
      } else {
        this.error_message = true;
        this.message = 'This is not CSV file!';
        return false;
      }
    },
    parseRow: function parseRow(row) {
      var row_trimed = row && row.trim();
      if (row_trimed === 'false' || row_trimed === 'N') return false;
      if (row_trimed === 'true' || row_trimed === 'Y') return true;
      if (!row_trimed || row_trimed === '') return false;
      if (row_trimed && row_trimed.includes(',')) return row_trimed.split(',');
      return row_trimed;
    },
    onBack: function onBack() {
      this.isHovering = false;
      this.bulkStep--;
      this.bulkStepError = false;
      this.csvFile = null;
    },
    // ===================== TABLAS ====================
    uploadTableFile: function uploadTableFile() {
      var _this = this;
      Papa.parse(this.csvFile, {
        header: true,
        skipEmptyLines: true,
        delimiter: "",
        // autodetecta ; o ,
        encoding: "UTF-8",
        complete: function complete(results) {
          var body = results.data;
          var records = [];
          var errorsList = [];
          var rowIndex = 2; // 1 es header, data empieza en 2
          var _iterator = _createForOfIteratorHelper(body),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var body_item = _step.value;
              var record = {};
              var hasError = false;

              // ===== LIMPIEZA =====
              for (var key in body_item) {
                var cleanKey = key.trim();
                var value = body_item[key];
                value = (value || '').replace(/\u00A0/g, ' ') // espacio invisible
                .replace(/\s+/g, ' ').trim();
                record[cleanKey] = value;
              }

              // ===== NORMALIZAR TYPE =====
              record['type'] = (record['type'] || '').replace(/\u00A0/g, ' ').replace(/\s+/g, ' ').trim().toUpperCase();

              // ===== VALIDACIONES =====

              if (_this.isInvalidText(record['proyecto'])) {
                tasks.toast.error("proyecto es requerida y no puede ser \"Null\". Verifique su archivo CSV.");
                return;
              }
              if (_this.isInvalidText(record['dataset'])) {
                tasks.toast.error("dataset es requerida y no puede ser \"Null\". Verifique su archivo CSV.");
                return;
              }
              if (_this.isInvalidText(record['Table'])) {
                tasks.toast.error("Table es requerida y no puede ser \"Null\". Verifique su archivo CSV.");
                return;
              }

              /*Solo para prod*/
              if (record['env'].toLowerCase() === 'prod') {
                if (_this.isInvalidText(record['official_source'])) {
                  tasks.toast.error("official_source es requerida y no puede ser \"Null\". Verifique su archivo CSV.");
                  return;
                }
                if (_this.isInvalidText(record['business_definition'])) {
                  tasks.toast.error("business_definition es requerida y no puede ser \"Null\". Verifique su archivo CSV.");
                  return;
                }
                if (_this.isInvalidText(record['zone'])) {
                  tasks.toast.error("zone es requerida y no puede ser \"Null\". Verifique su archivo CSV.");
                  return;
                }
              }

              /*Solo para FINANCIERA OH!**/

              if (isFOHDomain(window.userInfo.domain)) {
                // record['org'].toUpperCase() ==='FINANCIERA OH!' ){
                console.log(record, '-> table_load_logic');
                if (_this.isInvalidText(record['org'])) {
                  tasks.toast.error("El campo \"org\" no puede estar vac\xEDo ni contener \"Null\". Debe ser \"FINANCIERA OH!\". Corrija su archivo CSV antes de volver a cargar.");
                  return;
                } else if (record['org'].toUpperCase() !== 'FINANCIERA OH!') {
                  tasks.toast.error("org no es v\xE1lida. Debe ser \"FINANCIERA OH!\". Verifique su archivo CSV.");
                  return;
                }
                var domainMsg = " El dominio debe ser uno de: ".concat(FOH_DOMAINS.join(', '), ".");
                if (_this.isInvalidText(record['operator'])) {
                  tasks.toast.error("operator es requerido y no puede ser \"Null\". Verifique su archivo CSV.");
                  return;
                }
                if (_this.isInvalidEmail(record['operator'])) {
                  tasks.toast.error("operator debe ser un correo electr\xF3nico v\xE1lido con dominio ".concat(FOH_DOMAINS.join(' o '), ". Verifique su archivo CSV."));
                  return;
                }
                if (_this.isInvalidText(record['tech_data_custodiam'])) {
                  tasks.toast.error("tech_data_custodiam es requerido y no puede ser \"Null\". Verifique su archivo CSV.");
                  return;
                }
                if (_this.isInvalidEmail(record['tech_data_custodiam'])) {
                  tasks.toast.error("tech_data_custodiam debe ser un correo electr\xF3nico v\xE1lido con dominio ".concat(FOH_DOMAINS.join(' o '), ". Verifique su archivo CSV."));
                  return;
                }
                if (_this.isInvalidText(record['data_owner'])) {
                  tasks.toast.error("data_owner es requerido y no puede ser \"Null\". Verifique su archivo CSV.");
                  return;
                }
                if (_this.isInvalidEmail(record['data_owner'])) {
                  tasks.toast.error("data_owner debe ser un correo electr\xF3nico v\xE1lido con dominio ".concat(FOH_DOMAINS.join(' o '), ". Verifique su archivo CSV."));
                  return;
                }
                if (_this.isInvalidText(record['bus_data_steward'])) {
                  tasks.toast.error("bus_data_steward es requerido y no puede ser \"Null\". Verifique su archivo CSV.");
                  return;
                }
                if (_this.isInvalidEmail(record['bus_data_steward'])) {
                  tasks.toast.error("bus_data_steward debe ser un correo electr\xF3nico v\xE1lido con dominio ".concat(FOH_DOMAINS.join(' o '), ". Verifique su archivo CSV."));
                  return;
                }
                if (_this.isInvalidText(record['zone'])) {
                  tasks.toast.error("zone es requerida y no puede ser \"Null\". Verifique su archivo CSV.");
                  return;
                }
                if (_this.isInvalidText(record['description'])) {
                  tasks.toast.error("description es requerida y no puede ser \"Null\". Verifique su archivo CSV.");
                  return;
                }
                if (_this.isInvalidText(record['business_definition'])) {
                  tasks.toast.error("business_definition es requerida y no puede ser \"Null\". Verifique su archivo CSV.");
                  return;
                }
                if (_this.isInvalidText(record['public'])) {
                  tasks.toast.error("El campo \"public\" es requerido. Valores permitidos: Y, N, true, false. Verifique su archivo CSV.");
                  return;
                }
                if (_this.isInvalidText(record['length'])) {
                  tasks.toast.error("El campo \"length\" no puede ser \"Null\". Verifique su archivo CSV.");
                  return;
                }
                if (isNaN(record['length']) || record['length'] === '') {
                  tasks.toast.error("El campo \"length\" debe ser num\xE9rico. Verifique su archivo CSV.");
                  return;
                }
              }
              var typesFormatted = BIGQUERY_TYPES.join(', ');
              if (_this.isInvalidBigqueryTypes(record['type'])) {
                tasks.toast.error("El campo \"type\" debe ser un tipo v\xE1lido de BigQuery.\n\nTipos permitidos:\n".concat(typesFormatted, "\n\n . Verifique su archivo CSV."));
                return;
              }
              if (_this.isInvalidText(record['area'])) {
                tasks.toast.error("El campo \"area\" no puede ser nulo o \"Null\". Debe ser \"general\". Verifique su archivo CSV.");
                return;
              } else if (record['area'].toLowerCase() !== 'general') {
                tasks.toast.error("El area \"".concat(record['area'], "\" no es v\xE1lida. Debe ser \"general\". Verifique su archivo CSV."));
                return;
              }
              var errors = false;
              var schema = bulkSchemas['table'];
              for (var property in schema) {
                var _value = record[property];
                var fieldSchema = schema[property];
                if (fieldSchema.required && !_value) {
                  errorsList.push({
                    row: rowIndex,
                    field: property,
                    error: 'Requerido por schema'
                  });
                  hasError = true;
                  continue;
                }
                if (!fieldSchema.required && !_value) {
                  record[property] = fieldSchema.default;
                  continue;
                }
                if (fieldSchema.valid_values && _value) {
                  if (!fieldSchema.valid_values.includes(_value)) {
                    errorsList.push({
                      row: rowIndex,
                      field: property,
                      value: _value,
                      error: "Valores v\xE1lidos: ".concat(fieldSchema.valid_values)
                    });
                    hasError = true;
                  }
                }
                switch (property) {
                  case 'public':
                  case 'sensitive':
                  case 'primary_key':
                  case 'null':
                  case 'encrypted':
                  case 'final_table':
                    record[property] = _this.parseRow(_value);
                    break;
                }
              }
              if (!hasError) {
                records.push(record);
              }
              rowIndex++;
            }

            // ===== BLOQUEO TOTAL SI HAY ERRORES =====
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          if (errorsList.length > 0) {
            console.log("ERRORES DETECTADOS:", errorsList);
            _this.invalidRows = errorsList;
            tasks.toast.error("Archivo inv\xE1lido.\nSe encontraron ".concat(errorsList.length, " errores.\nCorrige el CSV antes de subir."));
            return;
          }

          // ===== SUBIDA =====
          _this.isLoading = true;
          TablesService.bulkLoad({
            records: records,
            source: _this.source
          }).then(function (response) {
            _this.isLoading = false;
            _this.showMessageServer = true;
            _this.tplToInform = response.data || [];
            _this.bulkStep++;
            if (response.success) {
              _this.colorAlert = _this.TYPE_SUCCESS;
              _this.messageServer = "Uploaded successfully!";
            } else {
              _this.colorAlert = _this.TYPE_ERROR;
              _this.messageServer = "Error al subir";
              _this.bulkStepError = true;
              tasks.toast.error(response.message || _this.MESSAGE_ERROR_UPLOAD);
            }
            _this.csvFile = null;
          }).catch(function (e) {
            console.error(e);
            _this.isLoading = false;
          });
        }
      });
    },
    // ============ METADATA DE TABLAS (FOH): formato campo-valor ============
    // Cada fila asigna un valor a un campo de metadata de una tabla existente.
    // Se agrupan las filas por tabla y se envía un registro por tabla con el
    // diccionario de actualizaciones.
    uploadTableMetadataFile: function uploadTableMetadataFile() {
      var _this2 = this;
      Papa.parse(this.csvFile, {
        header: true,
        skipEmptyLines: true,
        delimiter: "",
        // autodetecta ; o ,
        encoding: "UTF-8",
        complete: function complete(results) {
          var body = results.data;
          var isFOH = isFOHDomain(window.userInfo.domain);
          var grouped = {}; // "proyecto.dataset.tabla" -> { proyecto, dataset, Table, updates }
          var validFields = Object.keys(TABLE_METADATA_FIELDS);
          var rowIndex = 2; // 1 es header, data empieza en 2
          var _iterator2 = _createForOfIteratorHelper(body),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var body_item = _step2.value;
              var record = {};

              // ===== LIMPIEZA =====
              for (var key in body_item) {
                var cleanKey = key.trim();
                var value = body_item[key];
                value = (value || '').replace(/\u00A0/g, ' ') // espacio invisible
                .replace(/\s+/g, ' ').trim();
                record[cleanKey] = value;
              }

              // Fila de ayuda de la plantilla (empieza con #): se ignora
              if (String(record['proyecto'] || '').trim().startsWith('#')) {
                rowIndex++;
                continue;
              }

              // ===== VALIDACIONES =====
              for (var _i = 0, _arr = ['proyecto', 'dataset', 'tabla']; _i < _arr.length; _i++) {
                var field = _arr[_i];
                if (_this2.isInvalidText(record[field])) {
                  tasks.toast.error("Fila ".concat(rowIndex, ": \"").concat(field, "\" es requerido y no puede ser \"Null\". Verifique su archivo CSV."));
                  return;
                }
              }
              // Acepta el nombre del campo en español o en inglés
              var campo = normalizeMetadataField(record['campo_metadata']);
              var valor = record['valor_a_asignar'];
              var validNamesMsg = "".concat(Object.keys(TABLE_METADATA_FIELD_ALIASES).join(', '), " (o sus nombres internos en ingl\xE9s)");
              if (_this2.isInvalidText(campo)) {
                tasks.toast.error("Fila ".concat(rowIndex, ": \"campo_metadata\" es requerido. Campos v\xE1lidos: ").concat(validNamesMsg, "."));
                return;
              }
              if (!validFields.includes(campo)) {
                tasks.toast.error("Fila ".concat(rowIndex, ": el campo \"").concat(record['campo_metadata'], "\" no es actualizable. Campos v\xE1lidos: ").concat(validNamesMsg, "."));
                return;
              }
              if (_this2.isInvalidText(valor)) {
                tasks.toast.error("Fila ".concat(rowIndex, ": \"valor_a_asignar\" es requerido y no puede ser \"Null\" para el campo \"").concat(campo, "\"."));
                return;
              }

              // Validación del valor según el campo
              var fieldRule = TABLE_METADATA_FIELDS[campo];
              if (fieldRule.valid_values && !fieldRule.valid_values.includes(valor)) {
                tasks.toast.error("Fila ".concat(rowIndex, ": el valor \"").concat(valor, "\" no es v\xE1lido para \"").concat(campo, "\". Valores v\xE1lidos: ").concat(fieldRule.valid_values.join(', '), "."));
                return;
              }
              if (fieldRule.email) {
                if (_this2.isInvalidEmail(valor)) {
                  var domainMsg = isFOH ? " con dominio ".concat(FOH_DOMAINS.join(' o ')) : '';
                  tasks.toast.error("Fila ".concat(rowIndex, ": \"").concat(campo, "\" debe ser un correo electr\xF3nico v\xE1lido").concat(domainMsg, ". Verifique su archivo CSV."));
                  return;
                }
              }
              if (isFOH && fieldRule.foh_value && valor.toUpperCase() !== fieldRule.foh_value.toUpperCase()) {
                tasks.toast.error("Fila ".concat(rowIndex, ": el valor de \"").concat(campo, "\" debe ser \"").concat(fieldRule.foh_value, "\". Verifique su archivo CSV."));
                return;
              }

              // ===== AGRUPAR POR TABLA =====
              var tableKey = "".concat(record['proyecto'], ".").concat(record['dataset'], ".").concat(record['tabla']);
              if (!grouped[tableKey]) {
                grouped[tableKey] = {
                  proyecto: record['proyecto'],
                  dataset: record['dataset'],
                  Table: record['tabla'],
                  updates: {}
                };
              }
              // Booleanos textuales se normalizan; si el campo se repite para la
              // misma tabla, prevalece la última fila
              grouped[tableKey].updates[campo] = fieldRule.valid_values ? _this2.parseRow(valor) : valor;
              rowIndex++;
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
          var records = Object.values(grouped);
          if (records.length === 0) {
            tasks.toast.error('El archivo no contiene filas válidas.');
            return;
          }

          // ===== SUBIDA =====
          _this2.isLoading = true;
          TablesService.bulkLoad({
            records: records,
            source: _this2.source,
            bulk_mode: bulkTableMetadata
          }).then(function (response) {
            _this2.isLoading = false;
            _this2.showMessageServer = true;
            _this2.tplToInform = response.data || [];
            _this2.bulkStep++;
            if (response.success) {
              _this2.colorAlert = _this2.TYPE_SUCCESS;
              _this2.messageServer = "Uploaded successfully!";
            } else {
              _this2.colorAlert = _this2.TYPE_ERROR;
              _this2.messageServer = "Error al subir";
              _this2.bulkStepError = true;
              tasks.toast.error(response.message || _this2.MESSAGE_ERROR_UPLOAD);
            }
            _this2.csvFile = null;
          }).catch(function (e) {
            console.error(e);
            _this2.isLoading = false;
          });
        }
      });
    },
    // ============ METADATA DE COLUMNAS (FOH) ============
    uploadMetadataFile: function uploadMetadataFile(kind) {
      var _this3 = this;
      Papa.parse(this.csvFile, {
        header: true,
        skipEmptyLines: true,
        delimiter: "",
        // autodetecta ; o ,
        encoding: "UTF-8",
        complete: function complete(results) {
          var body = results.data;
          var records = [];
          var errorsList = [];
          var schema = bulkSchemas[kind];
          var isFOH = isFOHDomain(window.userInfo.domain);
          var rowIndex = 2; // 1 es header, data empieza en 2
          var _iterator3 = _createForOfIteratorHelper(body),
            _step3;
          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var body_item = _step3.value;
              var record = {};
              var hasError = false;

              // ===== LIMPIEZA =====
              for (var key in body_item) {
                var cleanKey = key.trim();
                var value = body_item[key];
                value = (value || '').replace(/\u00A0/g, ' ').replace(/\s+/g, ' ').trim();
                record[cleanKey] = value;
              }

              // ===== VALIDACIONES BASE (identidad de la tabla) =====
              if (_this3.isInvalidText(record['proyecto'])) {
                tasks.toast.error("proyecto es requerida y no puede ser \"Null\". Verifique su archivo CSV.");
                return;
              }
              if (_this3.isInvalidText(record['dataset'])) {
                tasks.toast.error("dataset es requerida y no puede ser \"Null\". Verifique su archivo CSV.");
                return;
              }
              if (_this3.isInvalidText(record['Table'])) {
                tasks.toast.error("Table es requerida y no puede ser \"Null\". Verifique su archivo CSV.");
                return;
              }
              {
                // ===== VALIDACIONES DE METADATA DE COLUMNAS =====
                // type, length y null ya no se cargan por CSV: salen del esquema de BigQuery.
                // transformation_logic quedó oculto para FOH: se descarta si viene en
                // plantillas antiguas para no actualizarlo por accidente
                delete record['transformation_logic'];
                if (_this3.isInvalidText(record['Column'])) {
                  tasks.toast.error("Column es requerida y no puede ser \"Null\". Verifique su archivo CSV.");
                  return;
                }
                if (isFOH) {
                  if (_this3.isInvalidText(record['business_definition'])) {
                    tasks.toast.error("business_definition es requerida y no puede ser \"Null\". Verifique su archivo CSV.");
                    return;
                  }
                }
              }

              // ===== SCHEMA =====
              for (var property in schema) {
                var _value2 = record[property];
                var fieldSchema = schema[property];
                if (fieldSchema.required && !_value2) {
                  errorsList.push({
                    row: rowIndex,
                    field: property,
                    error: 'Requerido por schema'
                  });
                  hasError = true;
                  continue;
                }
                if (!fieldSchema.required && !_value2) {
                  record[property] = fieldSchema.default;
                  continue;
                }
                if (fieldSchema.valid_values && _value2) {
                  if (!fieldSchema.valid_values.includes(_value2)) {
                    errorsList.push({
                      row: rowIndex,
                      field: property,
                      value: _value2,
                      error: "Valores v\xE1lidos: ".concat(fieldSchema.valid_values)
                    });
                    hasError = true;
                  }
                }
                switch (property) {
                  case 'public':
                  case 'sensitive':
                  case 'primary_key':
                  case 'null':
                  case 'encrypted':
                  case 'final_table':
                    record[property] = _this3.parseRow(_value2);
                    break;
                }
              }
              if (!hasError) {
                records.push(record);
              }
              rowIndex++;
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
          if (errorsList.length > 0) {
            console.log("ERRORES DETECTADOS:", errorsList);
            _this3.invalidRows = errorsList;
            tasks.toast.error("Archivo inv\xE1lido.\nSe encontraron ".concat(errorsList.length, " errores.\nCorrige el CSV antes de subir."));
            return;
          }

          // ===== SUBIDA =====
          _this3.isLoading = true;
          TablesService.bulkLoad({
            records: records,
            source: _this3.source,
            bulk_mode: kind
          }).then(function (response) {
            _this3.isLoading = false;
            _this3.showMessageServer = true;
            _this3.tplToInform = response.data || [];
            _this3.bulkStep++;
            if (response.success) {
              _this3.colorAlert = _this3.TYPE_SUCCESS;
              _this3.messageServer = "Uploaded successfully!";
            } else {
              _this3.colorAlert = _this3.TYPE_ERROR;
              _this3.messageServer = "Error al subir";
              _this3.bulkStepError = true;
              tasks.toast.error(response.message || _this3.MESSAGE_ERROR_UPLOAD);
            }
            _this3.csvFile = null;
          }).catch(function (e) {
            console.error(e);
            _this3.isLoading = false;
          });
        }
      });
    },
    // ================= DATASOURCE / DASHBOARD =================
    uploadTableauFile: function uploadTableauFile() {
      var _this4 = this;
      var self = this;
      var reader = new FileReader();
      reader.readAsText(this.csvFile);
      reader.onload = function (e) {
        var results = e.target.result.split('\n');
        var header = e.target.result.split('\n')[0];
        var separators = [',', ';', '|'];
        var separator = '';
        for (var _i2 = 0, _separators = separators; _i2 < _separators.length; _i2++) {
          separator = _separators[_i2];
          if (header.indexOf(separator) !== -1) break;
        }
        header = header.split(separator);
        var header_general = ['organization', 'object_name', 'domain', 'subdomain', 'data_operator', 'environment', 'database_engine', 'path_name', 'object_owner', 'sensitive_data', 'object_description'];
        var header_columns = ['business_definition', 'field_name', 'formula', 'masked', 'sensitive_data'];
        var body = [];
        var records = [];
        for (var index in results.filter(function (r) {
          return r;
        })) {
          if (index) {
            body.push(results[index].split(separator));
          }
        }
        var record = {};
        var bodyVisited = [];
        var column = {};
        var skipHeader = true;
        var rowKey = '';
        for (var _i3 = 0, _body = body; _i3 < _body.length; _i3++) {
          var body_item = _body[_i3];
          if (skipHeader) {
            skipHeader = false;
            continue;
          }
          record = {};
          if (_this4.bulkType === 'datasource') {
            record['columns'] = [];
          }
          for (var header_index in header) {
            if (header_general.includes(header[header_index] && header[header_index].trim())) {
              record[header[header_index].trim()] = self.parseRow(body_item[header_index]);
            }
          }
          if (!record.path_name || !record.object_name) {
            tasks.toast.error("path_name and object_name are required, check your csv file");
            return;
          }
          rowKey = "".concat(record.path_name, "_").concat(record.object_name);
          if (!bodyVisited.includes(rowKey)) {
            skipHeader = true;
            var _iterator4 = _createForOfIteratorHelper(body),
              _step4;
            try {
              for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                var body_item_j = _step4.value;
                if (skipHeader) {
                  skipHeader = false;
                  continue;
                }
                if (_this4.bulkType === 'datasource') {
                  column = {};
                  for (var column_index in header) {
                    if (header_columns.includes(header[column_index] && header[column_index].trim())) {
                      column[header[column_index].trim()] = self.parseRow(body_item_j[column_index]);
                    }
                  }
                  if (!column.field_name) {
                    tasks.toast.error("field_name is required, check your csv file");
                    return;
                  }
                  record['columns'].push(column);
                }
              }
            } catch (err) {
              _iterator4.e(err);
            } finally {
              _iterator4.f();
            }
            records.push(record);
          }
          bodyVisited.push(rowKey);
        }
        var args = {
          domain: window.userInfo.domain,
          records: records
        };
        _this4.isLoading = true;
        if (_this4.bulkType === 'datasource') {
          TblDatasourceService.bulkLoad(args).then(function (response) {
            _this4.bulkStep++;
            _this4.showMessageServer = true;
            _this4.isLoading = false;
            if (response.success) {
              _this4.tableauRecords = response.data;
              _this4.colorAlert = _this4.TYPE_SUCCESS;
              _this4.messageServer = "[".concat(response.data.length, "] record(s) uploaded successfully !");
              if (_this4.$gtm.enabled() && window.dataLayer) {
                window.dataLayer.push({
                  event: GA_EVENTS.BULK_UPLOAD,
                  object: 'tbl_datasource',
                  company_code: _this4.companyCode,
                  hash_email: _this4.stringToHash(userInfo.email),
                  module: 'data_platform'
                });
              }
            } else {
              _this4.colorAlert = _this4.TYPE_ERROR;
              _this4.messageServer = _this4.MESSAGE_ERROR_UPLOAD;
              _this4.bulkStepError = true;
            }
          });
        } else {
          TblDashboardService.bulkLoad(args).then(function (response) {
            _this4.bulkStep++;
            _this4.showMessageServer = true;
            _this4.isLoading = false;
            if (response.success) {
              _this4.tableauRecords = response.data;
              _this4.colorAlert = _this4.TYPE_SUCCESS;
              _this4.messageServer = "[".concat(response.data.length, "] record(s) uploaded successfully !");
              if (_this4.$gtm.enabled() && window.dataLayer) {
                window.dataLayer.push({
                  event: GA_EVENTS.BULK_UPLOAD,
                  object: 'tbl_dashboard',
                  company_code: _this4.companyCode,
                  hash_email: _this4.stringToHash(userInfo.email),
                  module: 'data_platform'
                });
              }
            } else {
              _this4.colorAlert = _this4.TYPE_ERROR;
              _this4.messageServer = _this4.MESSAGE_ERROR_UPLOAD;
              _this4.bulkStepError = true;
            }
          });
        }
      };
    },
    uploadBusinessTerm: function uploadBusinessTerm() {
      var _this5 = this;
      var self = this;
      var reader = new FileReader();
      reader.readAsText(this.csvFile);
      reader.onload = function (e) {
        var header = bulkTemplates[bulkBusiness].split(';');
        var body = _this5.getBody(e);
        var records = [];
        var _iterator5 = _createForOfIteratorHelper(body),
          _step5;
        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var body_item = _step5.value;
            var record = {
              'relationship': {}
            };
            for (var header_index in header) {
              var property = header[header_index].trim();
              var row = body_item[header_index];
              if (bulkTemplates[bulkBusiness].includes(property)) {
                switch (property) {
                  case 'definition':
                    record[property] = row.trim();
                    break;
                  default:
                    record[property] = self.parseRow(row);
                    break;
                }
              }
            }
            var errors = false;
            var businessTermSchema = bulkSchemas[bulkBusiness];
            for (var _property in businessTermSchema) {
              var value = record[_property];
              var fieldSchema = businessTermSchema[_property];
              if (fieldSchema.required && !value) {
                errors = true;
                tasks.toast.error("".concat(_property, " is required, check your csv file."));
                // alert(`${property} is required, check your csv file.`)
                break;
              } else if (_typeof(value) !== fieldSchema.type) {
                if (!Array.isArray(value)) {
                  errors = true;
                  tasks.toast.error("".concat(_property, " for ").concat(record.business_term, " requires ").concat(fieldSchema.type, ", check your csv file."));
                  // alert(`${property} for ${record.business_term} requires ${fieldSchema.type}, check your csv file.`)
                  break;
                }
              }
            }
            if (errors) {
              return;
            }
            records.push(record);
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
        var args = {
          records: records
        };
        BusinessTermService.bulkLoad(args).then(function (response) {
          _this5.bulkStep++;
          _this5.showMessageServer = true;
          _this5.isLoading = false;
          _this5.tableauRecords = [];
          _this5.tableauErrors = [];
          if (response.success) {
            _this5.tableauRecords = response.data;
            for (var index in _this5.tableauRecords) {
              var record = _this5.tableauRecords[index];
              console.log("record: ".concat(record));
              if (!record.success) {
                _this5.tableauErrors.push(record);
              }
            }
            if (_this5.tableauErrors.length === _this5.tableauRecords.length) {
              // Todos los términos a subir tuvieron errores
              _this5.colorAlert = _this5.TYPE_ERROR;
              _this5.messageServer = _this5.MESSAGE_ERROR_UPLOAD;
              _this5.bulkStepError = true;
            } else if (_this5.tableauErrors.length > 0) {
              // 1 o más términos tuvieron errores
              _this5.colorAlert = _this5.TYPE_WARNING;
              _this5.messageServer = _this5.MESSAGE_WARNING_UPLOAD;
              if (_this5.$gtm.enabled() && window.dataLayer) {
                window.dataLayer.push({
                  event: GA_EVENTS.BULK_UPLOAD,
                  object: 'bterm',
                  company_code: _this5.companyCode,
                  hash_email: _this5.stringToHash(userInfo.email),
                  module: 'data_platform'
                });
              }
            } else {
              // Todos los términos se subieron correctamente
              _this5.colorAlert = _this5.TYPE_SUCCESS;
              _this5.messageServer = "[".concat(response.data.length, "] record(s) uploaded successfully !");
              if (_this5.$gtm.enabled() && window.dataLayer) {
                window.dataLayer.push({
                  event: GA_EVENTS.BULK_UPLOAD,
                  object: 'bterm',
                  company_code: _this5.companyCode,
                  hash_email: _this5.stringToHash(userInfo.email),
                  module: 'data_platform'
                });
              }
            }
          } else if (!response.success || response.code >= 500) {
            _this5.colorAlert = _this5.TYPE_ERROR;
            _this5.messageServer = _this5.MESSAGE_ERROR_UPLOAD;
            _this5.bulkStepError = true;
          }
        });
      };
    },
    onSubmit: function onSubmit(event) {
      /*
       * Se anula el comportamiento por defecto del submit
       * que es recargar la página 13/04/20
       */
      event.preventDefault();
      var condicion = this.validateFile(this.csvFile);
      this.tableauRecords = [];
      this.tplToInform = [];
      console.log('[bulkType]', this.bulkType);
      if (condicion) {
        if (this.bulkType === bulkTable) {
          this.uploadTableFile();
        } else if (this.bulkType === bulkTableMetadata) {
          this.uploadTableMetadataFile();
        } else if (this.bulkType === bulkColumnMetadata) {
          this.uploadMetadataFile(bulkColumnMetadata);
        } else if ([bulkDatasource, bulkDashboard].includes(this.bulkType)) {
          this.uploadTableauFile();
        } else if (this.bulkType === bulkBusiness) {
          this.uploadBusinessTerm();
        }
      }
    },
    openDetails: function openDetails() {
      this.$refs.dialog.onOpen();
      // this.$bvModal.show(this.MODAL_INFORM_BULK)
    },
    downloadTemplate: function downloadTemplate() {
      var a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      var universalBOM = "\uFEFF";
      var template = "".concat(bulkTemplates[this.bulkType]).concat(bulkDummy[this.bulkType]);
      var encode = encodeURIComponent("".concat(universalBOM).concat(template));
      var url = "data:text/csv; charset=utf-8,".concat(encode);
      a.href = url;
      a.download = "template_".concat(this.bulkType, ".csv");
      a.click();
      window.URL.revokeObjectURL(url);
    }
  }
};